var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteMobeorShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 13H12.7612L26.2499 9.43879C26.3776 9.40515 26.4974 9.34655 26.6023 9.26639C26.7072 9.18622 26.7952 9.08607 26.8612 8.97172C26.9272 8.85736 26.9699 8.73107 26.9869 8.60013C27.0038 8.46918 26.9947 8.33618 26.9599 8.20879L25.9399 4.45879C25.7996 3.95427 25.4661 3.52537 25.0117 3.26497C24.5574 3.00457 24.0187 2.93364 23.5124 3.06754L4.47619 8.09254C4.22272 8.15833 3.98493 8.27403 3.77673 8.43286C3.56854 8.5917 3.39412 8.79047 3.26369 9.01754C3.13253 9.24182 3.04779 9.49018 3.01451 9.74786C2.98123 10.0055 3.00008 10.2673 3.06994 10.5175L3.99994 13.945C3.99994 13.9625 3.99994 13.9813 3.99994 14V25C3.99994 25.5305 4.21065 26.0392 4.58573 26.4142C4.9608 26.7893 5.46951 27 5.99994 27H25.9999C26.5304 27 27.0391 26.7893 27.4142 26.4142C27.7892 26.0392 27.9999 25.5305 27.9999 25V14C27.9999 13.7348 27.8946 13.4805 27.707 13.2929C27.5195 13.1054 27.2652 13 26.9999 13ZM24.0199 5.00004L24.7699 7.75879L21.9424 8.50879L18.4274 6.47879L24.0199 5.00004ZM15.6837 7.20004L19.1987 9.23004L14.5812 10.4488L11.0662 8.42129L15.6837 7.20004ZM5.75869 12.7775L5.00869 10.0175L8.32119 9.14254L11.8362 11.175L5.75869 12.7775ZM25.9999 25H5.99994V15H25.9999V25Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteMobeorShow);
export default __webpack_public_path__ + "static/media/Favorite Mobe or Show.2ce591845e94233202c02cc503737db2.svg";
export { ForwardRef as ReactComponent };